import { render, staticRenderFns } from "./ModalPayment.vue?vue&type=template&id=f95bfe60&scoped=true"
import script from "./ModalPayment.vue?vue&type=script&lang=js"
export * from "./ModalPayment.vue?vue&type=script&lang=js"
import style0 from "./ModalPayment.vue?vue&type=style&index=0&id=f95bfe60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95bfe60",
  null
  
)

export default component.exports